import { RouterProvider } from "react-router-dom";
import router from "@/routes/router";
import useApp from "@/viewModels/useApp";

import "@/styles/global.css";

function App() {
  useApp();

  return <RouterProvider router={router} />;
}

export default App;
